import { useSelector } from "react-redux"
import { autoTransFer, batchConfig, botConfig, isAdvanced, mainConfig, minTransactionValue, pool, slippage, spenToken, token } from "@/store"
import { Notification } from '@/components'
import { AppContext } from "@/context"
import { useContext } from "react"

export default function useIsFilled() {
    const _token = useSelector(token)
    const { Lang } = useContext(AppContext)
    const _spenToken = useSelector(spenToken)
    const _botConfig = useSelector(botConfig)
    const _slippage = useSelector(slippage)
    const _mainConfig = useSelector(mainConfig)
    const _pool = useSelector(pool)
    const _isAdvanced = useSelector(isAdvanced)
    const _batchConfig = useSelector(batchConfig)
    const _autoTransFer = useSelector(autoTransFer)
    const _minTransactionValue = useSelector(minTransactionValue)

    const isFill = () => {
        // console.log(_token?.address, '_token?.address');
        if (!_token?.address) return Notification.Warning(Lang.q1)
        // if (!_pairToken.address) return Notification.Warning(Lang.q2)
        if (!_spenToken?.address) return Notification.Warning(Lang.q3)
        if (!_slippage) return Notification.Warning("滑点未填写")
        if (_mainConfig.mode === 0) {
            if (Number(_botConfig.price) <= Number(_pool.price) && _botConfig.price && _isAdvanced && !_batchConfig.isBatch) return Notification.Warning(Lang.targetPriceMaxAndMin)

            const textArr = [Lang.Amount, Lang.Quantity]
            if (!_botConfig.minBuy || !_botConfig.maxBuy) {
                return Notification.Warning(`${Lang.q5}${textArr[_mainConfig.isBuyAmount]}`)
            }
        }

        if (_mainConfig.mode === 1) {
            // if (!_botConfig.price) return Notification.Warning(Lang.q4)
            if (Number(_botConfig.price) >= Number(_pool.price) && _botConfig.price && _isAdvanced && !_batchConfig.isBatch) return Notification.Warning(Lang.targetPriceMaxAndMin)

            const textArr = [Lang.Amount, Lang.Quantity, Lang.percentage]
            if (!_botConfig.minSell || !_botConfig.maxSell) {
                return Notification.Warning(`${Lang.q6}${textArr[_mainConfig.isSellAmount]}`)
            }
        }

        if (_mainConfig.mode === 2) {
            if (!_botConfig.buyPro) return Notification.Warning(Lang.q7)

            const textArr = [Lang.Amount, Lang.Quantity]
            if (!_botConfig.minBuy || !_botConfig.maxBuy) {
                return Notification.Warning(`${Lang.q5}${textArr[_mainConfig.isBuyAmount]}`)
            }
            const textArr1 = [Lang.Amount, Lang.Quantity, Lang.percentage]
            if (!_botConfig.minSell || !_botConfig.maxSell) {
                return Notification.Warning(`${Lang.q6}${textArr1[_mainConfig.isSellAmount]}`)
            }
        }

        if (_mainConfig.mode === 3) {
            const textArr = [Lang.Amount, Lang.Quantity]
            if (!_botConfig.minBuy || !_botConfig.maxBuy) {
                return Notification.Warning(`${Lang.q5}${textArr[_mainConfig.isBuyAmount]}`)
            }
            const textArr1 = [Lang.Amount, Lang.Quantity, Lang.percentage]
            if (!_botConfig.minSell || !_botConfig.maxSell) {
                return Notification.Warning(`${Lang.q6}${textArr1[_mainConfig.isSellAmount]}`)
            }
            if (Number(_botConfig.minPrice) > Number(_botConfig.maxPrice)) return Notification.Warning('最低价格应小于最高价格')

            if (!_botConfig.minPrice) return Notification.Warning(Lang.q12)
            if (!_botConfig.maxPrice) return Notification.Warning(Lang.q13)
        }
        if ((_botConfig.minTime === '' || _botConfig.maxTime === '') && !_batchConfig.isBatch) return Notification.Warning(Lang.q8)
        // console.log(typeof (_botConfig.minTime), _botConfig.maxTime, '_botConfig');
        if (Number(_botConfig.minTime) > Number(_botConfig.maxTime)) return Notification.Warning('时间间隔最小值应小于最大值')
        // if (_batchConfig.isBatch && !_batchConfig.number) return Notification.Warning(Lang.q9)
        if (_botConfig.isStartTime && !_mainConfig.startTime) return Notification.Warning(Lang.q10)
        if (_autoTransFer && !_minTransactionValue) return Notification.Warning(Lang.q11)

        return 'filled'
    }

    return isFill
}
